/* eslint-disable no-param-reassign */
import {
  reactive, ref, computed, watch,
} from '@vue/composition-api'
import formatDate from '@/utils/date-format'

export default function useTransactionBulksList(ctx) {
  const tableColumns = [
    'id',
    {
      label: 'job state',
      key: 'job_state',
    },
    'action',
    {
      label: 'created at',
      key: 'created_at',
      formatter: val => formatDate(val),
      sortable: true,
    },
    'download',
  ]
  const operationOptions = ['add', 'deduct']
  const statesOptions = ['created', 'started', 'in_progress', 'finished', 'failed']
  const sortBy = 'created_at'
  const bulksList = ref([])
  const loading = ref(false)
  const page = ref(1)
  const perPage = ref(10)
  const filter = reactive({
    id: null,
    jobState: null,
    operation: null,
  })

  const fetchBulks = async () => {
    loading.value = true
    const bulks = await ctx.root.$store.dispatch('billing/getTransactionBulks')
    bulksList.value = bulks.data.data.map(el => ({
      ...el,
      downloading: false,
    }))
    loading.value = false
    if (ctx.root.$route.query.id) {
      filter.value = ctx.root.$route.query.id
    }
  }

  const tableData = computed(() => {
    if (filter.id) return bulksList.value.filter(item => item.id === filter.id)
    if (filter.jobState && filter.operation) return bulksList.value.filter(item => item.job_state === filter.jobState && item.action === filter.operation)
    if (filter.jobState || filter.operation) return bulksList.value.filter(item => item.job_state === filter.jobState || item.action === filter.operation)
    return bulksList.value
  })

  watch(tableData, () => {
    page.value = 1
  })

  const canDownload = data => data.item.job_state === 'finished' || data.item.job_state === 'failed'
  const downloadBulk = async evt => {
    evt.item.downloading = true
    const result = await ctx.root.$store.dispatch('billing/getTransactionBulkDetails', evt.item.id)
    const url = result.data.data.outbound_file_url
    evt.item.downloading = false
    window.open(url)
  }

  fetchBulks()
  return {
    canDownload,
    tableColumns,
    fetchBulks,
    bulksList,
    loading,
    perPage,
    page,
    filter,
    sortBy,
    operationOptions,
    statesOptions,
    tableData,
    downloadBulk,
  }
}
